/**
 * @generated SignedSource<<e52b0f53c046789fd1461f5b978ec5cb>>
 * @lightSyntaxTransform
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInfo_AddendumPage_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "folderName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewOnly",
      "storageKey": null
    }
  ],
  "type": "AccessRequest",
  "abstractKey": null
};

node.hash = "b10faa52c7eeb3aec2b1c524eb72afc5";

export default node;
